module.exports = __webpack_public_path__ + "img/lemon.be5030ca.webp";